/// <amd-module name="Artifacts/Root/components/UnyankYankModal" />
import { CommandPanel } from "Artifacts/Root/components/CommandPanel";
import { ComponentState } from "Artifacts/Root/Constants";
import { registerModal } from "Artifacts/Root/containers/ModalManager";
import { connectDynamicModules } from "Artifacts/Root/redux";
import { IRootModuleState } from "Artifacts/Root/redux/Contracts";
import { RootModule } from "Artifacts/Root/redux/Module";
import * as Res from "Artifacts/Root/Resources";
import { IPackageVersionIdentity } from "Artifacts/Root/types";
import * as React from "react";
import { connect } from "react-redux";

export interface IUnlistRelistModalProps {
  packages?: IPackageVersionIdentity[];
  onDismiss: () => void;
  onUnlistRelist: () => void;
}

interface IMapStateToProps {
  componentState: ComponentState;
}

export const UnyankYankModalId = "UnyankYankModal";

const UnyankYankModal: React.FC<IUnlistRelistModalProps & IMapStateToProps> = ({
  packages,
  onDismiss,
  onUnlistRelist,
  componentState,
}) => {
  const isListedValueToServer = packages
    ? !(packages.filter((v) => v.isListed === true).length > 0)
    : false;

  const commandName = isListedValueToServer ? Res.UnyankCommand : Res.YankCommand;
  const dialogTitle = isListedValueToServer
    ? Res.UnyankPackagesDialogTitle
    : Res.YankPackagesDialogTitle;
  const warningText = isListedValueToServer
    ? Res.UnyankDialog_ConfirmText_VersionsList
    : Res.YankDialog_ConfirmText_VersionsList;

  return (
    <CommandPanel
      title={dialogTitle}
      description=""
      packages={packages}
      onDismiss={onDismiss}
      onSubmit={onUnlistRelist}
      submitButtonComponentState={componentState}
      submitButtonText={commandName}
      warningText={warningText}
      warningTextFWLinkId="2173234"
    ></CommandPanel>
  );
};

const mapStateToProps = (state: IRootModuleState): IMapStateToProps => {
  const rootState = state.rootState;
  return {
    componentState: rootState.unlistRelistCommandState,
  };
};

const ConnectedUnlistRelistModal = connectDynamicModules(
  connect(mapStateToProps)(UnyankYankModal),
  [RootModule],
);

registerModal(UnyankYankModalId, ConnectedUnlistRelistModal);

export { UnyankYankModal };
